<!-- Orbi message input (PCSA-13160). Figma input node 7203:10062.
     Enter = send, Shift+Enter = newline. Mic shown only where the browser
     supports the Web Speech API. -->
<div
  class="orbi-input"
  [class.orbi-input--listening]="listening"
  [class.orbi-input--focused]="focused"
  [class.orbi-input--single-line]="singleLine"
>
  <!-- Optional leading icon (entry point / PCSA-13157: the Orbi AI mark).
       Hidden while listening AND on focus, so the text caret takes its place
       when the field is active (per design).

       Clicking the mark focuses the field (PCSA-13441: "selecting the Orbi icon
       OR the Ask a Question field"). Delegating to focus() rather than emitting
       `activate` directly keeps ONE activation path — the field's focus handler —
       so the icon and the field can never diverge, and a tap on the mark still
       lands the caret in the field when no conversation is active yet. It stays
       aria-hidden with no tabindex: keyboard users reach the adjacent textarea,
       which is the same activation. -->
  <img *ngIf="showLeadingIcon" class="orbi-input__lead" [src]="leadingIconSrc" alt="" aria-hidden="true" (click)="focus()" />

  <!-- `rows="1"` is the STARTING height, not the height (PCSA-13548): the field
       grows a line at a time as the prompt wraps, up to the stylesheet's cap, and
       the component writes that height (see `autoGrow` — a textarea cannot be
       sized to its content from CSS). The entry bar (`--single-line`) opts out
       and truncates on one line instead, which is also why `wrap` is turned off
       there — soft wrapping is what the panel field measures. -->
  <textarea
    #field
    class="orbi-input__field"
    rows="1"
    [attr.wrap]="singleLine ? 'off' : null"
    [formControl]="control"
    [attr.readonly]="disabled ? '' : null"
    [attr.aria-disabled]="disabled ? 'true' : null"
    [attr.aria-label]="placeholder"
    [attr.placeholder]="displayPlaceholder"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onUserInput()"
    (keydown)="onKeydown($event)"
    (paste)="onPaste($event)"
  ></textarea>

  <ng-container *ngIf="locked">
    <span #lockedDisclosure class="orbi-input__disclosure">
      <button
        #lockedInfoTrigger
        type="button"
        class="orbi-input__action orbi-input__info material-icons-round"
        aria-label="Why is this feature unavailable?"
        [attr.aria-expanded]="lockedInfoOpen"
        (click)="toggleLockedInfo()"
      >
        info
      </button>

      <span *ngIf="lockedInfoOpen" class="orbi-input__popup" (keydown.escape)="onLockedInfoEscape($event)"
        >This feature is unavailable right now for safety reasons. To start a new conversation,
        <button type="button" class="orbi-input__popup-link" (click)="onSignOut()">sign out</button>
        and back in.</span
      >
    </span>

    <button
      type="button"
      class="orbi-input__action orbi-input__mic orbi-input__mic--struck material-icons-round"
      aria-label="Start voice input, unavailable"
      aria-disabled="true"
    >
      mic
    </button>
  </ng-container>

  <button
    *ngIf="showMic"
    type="button"
    class="orbi-input__action orbi-input__mic material-icons-round"
    [class.orbi-input__mic--active]="listening"
    [attr.aria-label]="listening ? 'Stop voice input' : 'Start voice input'"
    [attr.aria-disabled]="disabled ? 'true' : null"
    (click)="toggleVoice()"
  >
    mic
  </button>

  <ng-container *ngIf="showHistory && !canSend && !listening && !locked">
    <span class="orbi-input__divider" aria-hidden="true"></span>
    <button
      type="button"
      class="orbi-input__action orbi-input__history material-icons-round"
      aria-label="Open conversation history"
      [attr.aria-disabled]="disabled ? 'true' : null"
      (click)="onHistory()"
    >
      history
    </button>
  </ng-container>

  <button *ngIf="showSend" type="button" class="orbi-input__action orbi-input__send" aria-label="Send message" (click)="submit()">
    <img class="orbi-input__send-arrow" src="assets/images/orbi-send-arrow-icon.svg" alt="" aria-hidden="true" />
  </button>
</div>
